/* eslint-disable import/extensions */
import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import Localizer from 'thdlocalizer';
import config from '../../../../helpers/config';

const getStoreFromLocalizer = () => {
  const localStore = Localizer.getLocalizedStore();
  const defaultStore = {
    storeId: 121,
    storeFullName: 'Cumberland - Atlanta, GA',
    storeName: 'Cumberland',
    zipcode: '30339',
  };

  return localStore === null || localStore === undefined ? defaultStore : localStore;
};

export default function checkStoreAvailability() {
  const store = getStoreFromLocalizer();
  const url = `${config.mandiBaseUrl}${config.checkStoreAvailabilityApi}?service=1&storeNumber=${store.storeId}`;

  return axios.get(url, {
    withCredentials: true,
  });
}
